module.exports = __webpack_public_path__ + "img/product_2.17b038fb.jpg";